import client from 'api/client';
import { AxiosRequestConfig } from 'axios';

export function get(customConfig?: AxiosRequestConfig) {
    const url = `/service_providers_top_picks`;
    return client.get(url, customConfig);
}
